export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_07-d20e9e798479a4a4a1d62453007113be.jpg";